export const environment = {
  production: false,
  apibaseUrl: 'https://apportis-api.azurewebsites.net/api',
  hubUrl: 'https://apportis-api.azurewebsites.net/apportis-devhub',
  apiKey: 'AIzaSyA2uQfzGV-XLYWnExvVJRpgPIY7ayQec8M',
  tokboxApiKey: '46276492',
  ipaddress: 'https://jsonip.com',
  tinyMceKey: 'nf7v90it3ed3az8x7bqnmy464ixjxtvzqiy634petxn40j2y'
};

